import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchUsersCount } from "../utils";

const UserHomeBanner = () => {
    const { t } = useTranslation();
    const [usersCount, setUsersCount] = useState<string>("");

    
    useEffect(() => {
        fetchUsersCount().then((res) => {setUsersCount(res.totalUsers)})
    }, [])

    return (
    <Box style={{backgroundColor: '#F6F6F6', borderBottom: '1px solid #AFAFAF',  borderTop: '1px solid #AFAFAF', paddingTop: '16px', paddingBottom: '16px', gap: "16px"}}>
        <Box mx={"auto"} maxWidth={'200px'} gap={'20px'}>
        <Typography gap={'10px'} color="#FF395D" fontSize={'28px'} fontWeight={'700'} lineHeight={'38.08px'} align='center'>{usersCount}</Typography>
        <Typography gap={'8px'} color="#4D4D4D" fontWeight={'400'} lineHeight={'16.8px'} letterSpacing={'-0.41px'} align='center'>{t('statistics.subtitle')}</Typography>
        <Typography marginTop={'20px'} gap={'8px'} color="#000000" fontSize={'18px'} fontWeight={'600'} lineHeight={'16.8px'} letterSpacing={'-0.41px'} align='center'>{t('statistics.header')}</Typography>
        </Box>
    </Box>
    )
}

export default UserHomeBanner;